import { debugLog } from '@schibsted-nmp/advertising-shared';

import type { Api } from './Api/index.js';

const directlyRenderedSlotIds = new Set<string>();
const consumedFromDom = new Set<string>();

export namespace DirectRenderedSlots {
  // Intentionally does NOT check consumedFromDom - has() must keep returning true
  // for DOM-detected slots even after consume(), because onSlotRenderEnded relies
  // on has() to prevent GAM from hiding the directly rendered ad.
  export function has(slotId: string): boolean {
    return directlyRenderedSlotIds.has(slotId) || existsInDom(slotId);
  }

  export function consume(slotId: string): boolean {
    if (directlyRenderedSlotIds.delete(slotId)) return true;
    if (consumedFromDom.has(slotId)) return false;
    if (existsInDom(slotId)) {
      consumedFromDom.add(slotId);
      return true;
    }
    return false;
  }

  function existsInDom(slotId: string): boolean {
    if (typeof document === 'undefined') return false;
    try {
      return !!document.querySelector(
        `#${CSS.escape(slotId)} [data-rlv-direct-rendered]`
      );
    } catch {
      return false;
    }
  }

  export function simulate(slotId: string) {
    directlyRenderedSlotIds.add(slotId);
    console.info(
      `[ADVT] Simulated direct render for slot '${slotId}' — it will be excluded from the next GAM refresh`
    );
  }

  export function register(relevantDigital: Api.Loaded) {
    relevantDigital.addAdsCallbacks({
      slotRenderEnded(ev) {
        if (!ev.directRender) return;

        const slotId = ev.slot.getSlotElementId();
        directlyRenderedSlotIds.add(slotId);

        debugLog(
          `Slot '${slotId}' was directly rendered by Relevant Yield, excluding from GAM refresh`
        );
      }
    });
  }
}
